import { getApiConstants } from '../../utils/apiConstants';

export const catalogConstants = {
    LOAD: getApiConstants('CATALOG_LOAD'),
};

export default catalogConstants;